import { render, staticRenderFns } from "./StockTakingPlus.vue?vue&type=template&id=71fb8196&"
import script from "./StockTakingPlus.vue?vue&type=script&lang=js&"
export * from "./StockTakingPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports